/* @flow */

export default {
  root: {
    width: 16,
    height: 16,
  },
};
